import React from "react";

const services = [
  {
    title: "Web Development",
    desc: "Full-stack web applications tailored for dynamic and user-friendly experiences.",
  },
  {
    title: "Mobile App Development",
    desc: "Android & cross-platform apps with seamless user experiences.",
  },
  {
    title: "Game Development",
    desc: "Engaging mobile and web-based games from concept to launch.",
  },
  {
    title: "Blockchain Solutions",
    desc: "dApps, DEXs, and smart contracts for secure blockchain systems.",
  },
  {
    title: "SaaS Solutions",
    desc: "Cloud-based SaaS products enabling business efficiency & innovation.",
  },
  {
    title: "IT Project Management",
    desc: "End-to-end IT project execution, from planning to deployment.",
  },
];

export default function Services() {
  return (
    <section id="services" className="max-w-6xl mx-auto py-16 px-6">
      <h2 className="text-3xl font-bold text-center text-blue-600 mb-12">Services</h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
        {services.map((srv, idx) => (
          <div key={idx} className="bg-white shadow-lg rounded-xl p-6 hover:shadow-xl transition">
            <h3 className="text-xl font-semibold mb-3">{srv.title}</h3>
            <p className="text-gray-600">{srv.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
